// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"24232e7d","703":"9c90e9a8","787":"fc941f00"}[chunkId] + ".chunk.js";
};